import { createFileRoute } from '@tanstack/react-router'
import { InspectionScheduling } from 'pages/inspectionScheduling/InspectionScheduling'
import { schedulingSearchParams } from 'routes/scheduling/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return <InspectionScheduling orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/scheduling/')({
  component: RouteComponent,
  validateSearch: schedulingSearchParams,
  staticData: {
    title: 'Scheduling',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
